export class Postal{
    constructor(
        public _id: string,
        public titulo: string,
        public precio: string,
        public tiempo: string,
        public dias: number,
    ){
    }
}